import { render, staticRenderFns } from "./PagoMasivoNominasForm.vue?vue&type=template&id=5584e7f2&"
import script from "./PagoMasivoNominasForm.vue?vue&type=script&lang=js&"
export * from "./PagoMasivoNominasForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports